const titleSlideEdit = 'title-slide-edit'

export default {
  methods: {
    backupUpdateSlide(newData) {
      const oldData = {
        ...newData,
        value: Object.prototype.hasOwnProperty.call(newData, 'value') ? this.slideActive.title : undefined,
        subheading: Object.prototype.hasOwnProperty.call(newData, 'subheading') ? this.slideActive.subheading : undefined,
        titleDesc: Object.prototype.hasOwnProperty.call(newData, 'titleDesc') ? this.slideActive.titleDesc : undefined,
      }

      if (oldData.value !== newData.value || oldData.subheading !== newData.subheading
          || oldData.titleDesc !== newData.titleDesc) {
        this.addHistoryUpdateTitleSlide(newData, oldData)
      }
    },

    async restoreUpdateTitleSlide(data) {
      if (data.value === null) {
        data.value = ''
      }
      if (data.titleDesc === null) {
        data.titleDesc = ''
      }
      if (data.subheading === null) {
        data.subheading = ''
      }
      if (data.idName === titleSlideEdit && data.value === undefined) {
        data.value = ''
      }
      await this.updateSlide(data, false)
      this.key = `${(new Date()).getTime()} ${Math.random().toString(36).substring(2)}`
      if (this.callbackAfterRestore) {
        this.callbackAfterRestore(data)
      }
    },

    updateValueTitle(data) {
      this.addHistoryUpdateTitleSlide(
        {
          idName: titleSlideEdit,
          value: data.newValue,
        },
        {
          idName: titleSlideEdit,
          value: data.oldValue,
        },
      )
    },

    addHistoryUpdateTitleSlide(newValue, oldValue) {
      this.addActionToHistory({
        type: 'UpdateTitleSlide',
        data: oldValue,
        newData: newValue,
        slideActiveId: this.slideActive.id,
      })
    },
  },
}
